module.exports = __webpack_public_path__ + "static/media/2.007f30b0.jpg";